const defineUpperCaseLanguage = (languageString: string) => {
  if (languageString.includes("en")) return "EN";

  if (languageString.includes("pt")) return "PT";

  return "ES";
};

export default defineUpperCaseLanguage;
